// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SAol","colBig":"styles_colBig__2ekOK","colSmall":"styles_colSmall__3_oMe"};